import { useEffect, useState } from "react";
import { FileInput } from "../../../../theme/Component/FileInput";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { Singleton } from "../../../../../core/services/Singleton";
import { ContractService } from "../../../../../core/services/ContractService";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { CreateUBLInvoiceItems } from "./CreateUBLInvoice/CreateUBLInvoiveItem";
import { HistoryUBLInvoice } from "./HistoryUBLInvoice";
import { FileService } from "../../../../../core/services/FileService";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectAccountantConceptForCashDesk } from "./CreateUBLInvoice/SelectAccountantConceptForCashDesk";
import { FireElectronicDocument } from "./FireElectronicDocument/FireElectronicDocument";
import { AccountantDocumentList } from "./AccountantDocumentList/AccountantDocumentList";
import { SelectAccountantConceptCatalogForSalesInvoice } from "./SelectAccountantConceptCatalogForSalesInvoice";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "./SelectAccountantConceptCatalogForSupplierInvoice";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { DocumentPDF } from "./CreateUBLInvoice/CreateUBLInvoice";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { InputDate } from "../../../../theme/Input/InputDate";

interface Props {
    _onChange2?: Function;
    _multipleUBLs?: boolean;
    entry?: "Accounting" | "CashReimbursement";
    typeDocument?: "sell" | "Supplier" | "None";

}

export const ImportUBLInvoice = ({ _onChange2, _multipleUBLs, entry = "Accounting", typeDocument = "None" }: Props) => {


    const single = Singleton.getInstance();
    const contracService = new ContractService();
    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLInvoice);
    const fileService = new FileService();


    const [idconcept, setIDConcep] = useState<number>(0);
    const [file, setFile] = useState<any>({});
    const [observation, setObservation] = useState<any>('');
    const [observationAdd, setObservationAdd] = useState<any>('');
    const [fileType, setFileType] = useState<string>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);

    const [modal, setModal] = useState<any>({ name: 'Items de la factura', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalB, setModalB] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalRegis, setModalRegis] = useState<any>({ name: 'Registrar factura a contrato', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalFire, setModalFire] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalAccount = useModal("Causar Factura", MODAL_md);
    const [modalVisor, setModalVisor] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        setFileType(bean.MediaContext?.type || bean.Media?.split('.').pop())
        setDonwloadURL(fileService.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])

    const importUBLInvoice = () => {
        single.spinner(true);
        contracService.importUBLInvoice(idconcept, file.Media, file.MediaContext, null, single.getCurrenDate(), null, single.getAccountID(), observationAdd).subscribe(
            (resp: any) => {

                console.log(resp);

                toast.success("Factura importada exitosamente");
                // if (resp.DataBeanProperties.ObjectValue) {                                        
                // } else {
                //     toast.error("Factura no pudo ser importada");
                // }
                setFile({});
                _onChange2(true);

                single.spinner(false);
            }
        )
    }

    const importUBLInvoiceContainer = () => {
        single.spinner(true);
        contracService.importUBLInvoiceContainer(idconcept, file.Media, file.MediaContext, null, single.getCurrenDate(), null, single.getAccountID(), observationAdd).subscribe(
            (resp: any) => {
                console.log(resp);

                toast.success("Factura importada exitosamente");
                // if (resp.DataBeanProperties.ObjectValue) {
                //     let temp = [];
                //     temp.push(resp.DataBeanProperties.ObjectValue);

                //     setLista(temp);
                // } else {
                //     toast.error("Factura no pudo ser importada");
                // }
                setFile({});
                _onChange2(true);

                single.spinner(false);
            }
        )
    }

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await fileService.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    const head = [
        { title: 'ID', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Procesar', property: 'isValid', visible: true },
        { title: 'Nit Proveedor', property: 'AccountSupplierNit', visible: true },
        { title: 'Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Entrada Almacén', property: 'EAFMnemonic', visible: true, mask: MASK_DATE },
        { title: 'Consecutivo Entrada', property: 'EAFConsecutive', visible: true },
        { title: 'Fecha Entrada', property: 'EAFDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Procesamiento', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Estado Salidas', property: 'OutputCostStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Abrir Factura', icono: 'ri-file-list-line', visible: true, evento: () => { setModal({ ...modal, "name": "Abrir archivo", "view": true, "format": `${fileType !== "pdf" && "jpg" && "png" ? "modal-sm" : "modal-xl"}` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura ${bean.IDUBLInvoice}` }) } },
            { titulo: 'Transmitir/Descargar Documento Electrónico', icono: 'ri-list-ordered', visible: true, evento: () => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: true, evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
            { titulo: 'Contabilizar Factura Electrónica', icono: 'ri-list-ordered', visible: true, evento: () => { modalAccount.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setRowBean = (ob: any) => {
        if (_onChange2) {
            _onChange2(ob)
        }
        setBean(ob)
    }

    const [type, setType] = useState<string>("");
    const [documentError, setDocumentError] = useState<any>([]);
    const [document, setDocument] = useState<any>([]);
    const [recordDate, setRecordDate] = useState<any>();

    const createAccountantDocumentForUBLInvoice = () => {
        instance.createAccountantDocumentForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, recordDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true, "name": "Causación Contable" });
                    modalAccount.close();
                    setModal({ ...modal, "view": false });

                }
            ).catch(err => toast.error(err));
    }

    return (
        <>

            <div className="row">
                {typeDocument === "sell" ? (

                    <div className="col-md-6">
                        {entry == "CashReimbursement" ?
                            <SelectAccountantConceptForCashDesk idSelector={idconcept} onChange={setIDConcep} />
                            :
                            <SelectAccountantConceptCatalogForSalesInvoice idSelector={idconcept} onChange={setIDConcep} />
                        }
                    </div>
                ) : typeDocument === "Supplier" ? (
                    < div className="col-md-6">
                        <SelectAccountantConceptCatalogForSupplierInvoice idSelector={idconcept} onChange={setIDConcep} />
                    </div>
                ) : (
                    <>
                        <div className="col-md-6">
                            <label>Tipo de Factura</label>
                            <select className="form-select" value={type} onChange={(e) => { setType(e.target.value) }}>
                                <option value={""}>...</option>
                                <option value={"Venta"}>Venta</option>
                                <option value={"Proveedor"}>Proveedor</option>
                            </select>
                        </div>

                        {type === "Venta" &&
                            <div className="col-md-6">
                                {entry == "CashReimbursement" ?
                                    <SelectAccountantConceptForCashDesk idSelector={idconcept} onChange={setIDConcep} />
                                    :
                                    <SelectAccountantConceptCatalogForSalesInvoice idSelector={idconcept} onChange={setIDConcep} />
                                }
                            </div>
                        }

                        {type === "Proveedor" &&
                            < div className="col-md-6">
                                <SelectAccountantConceptCatalogForSupplierInvoice idSelector={idconcept} onChange={setIDConcep} />
                            </div>
                        }
                    </>
                )}

                <div className="col-md-12">
                    <FileInput directory="files" onCreate={(e) => { setFile(e) }} />
                </div>

                <div className="col-md-12 mt-3">
                    {file.Media &&
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea name="obs" className="form-control" value={observationAdd} onChange={(e) => { setObservationAdd(e.target.value) }} ></textarea>
                            </div>
                        </div>
                    }

                    {_multipleUBLs ?
                        <div className="col-md-6">
                            <BasicButton disable={!file.Media && !idconcept} icon="ri-contacts-book-upload-line" eventClick={importUBLInvoiceContainer}>Importar Facturas</BasicButton>
                        </div>
                        :
                        <div className="col-md-6">
                            <BasicButton disable={!file.Media && !idconcept} icon="ri-contacts-book-upload-line" eventClick={importUBLInvoice}>Importar Factura</BasicButton>
                        </div>
                    }

                </div>

                {/* <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={(e) => { setRowBean(e) }} />
                </div> */}
            </div >

            {
                modalB.view &&
                <Modal modal={modalB} updateModal={setModalB} >
                    <CreateUBLInvoiceItems idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                </Modal>
            }

            {
                modalRegis.view &&
                <Modal modal={modalRegis} updateModal={setModalRegis}>
                    <div className="row">
                        <div className="col-md-12">
                            {/* <PrintJson json={contract}/> */}
                            <label>Observaciones</label>
                            <textarea className="form-control" value={observation} onChange={(e) => { setObservation(e.target.value) }}></textarea>
                        </div>
                    </div>
                </Modal>
            }

            {
                modalC.view &&
                <Modal modal={modalC} updateModal={setModalC} >
                    <HistoryUBLInvoice _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
                </Modal>
            }

            {
                modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={() => { }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="iframe-container">
                                {fileType ?
                                    <>
                                        {fileType === 'pdf' && (
                                            urlFile ? (
                                                <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                            ) : (
                                                <p>Cargando PDF...</p>
                                            )
                                        )}
                                        {fileType === "jpg" || fileType === "png" &&
                                            (
                                                <img src={urlFile} alt="Image Preview" width="100%" />
                                            )
                                        }
                                        {fileType !== "pdf" && "jpg" && "png" &&
                                            <>
                                                <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        No se pudo cargar el Documento
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            <Modal modal={modalFire} updateModal={setModalFire} >
                <FireElectronicDocument _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                <AccountantDocumentList _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {/* visor de documentos */}
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            // <PrintJson json={documentError} />
                            <ul className="group-list">
                                {documentError.map((item: any, index: number) => {
                                    return (
                                        <li key={index} className="group-list-item">{item}</li>
                                    )
                                })}
                            </ul>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={modalAccount.modal} updateModal={modalAccount.setModal} eventModal={() => { createAccountantDocumentForUBLInvoice() }} onSubmitLabel="Procesar" >
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                    </div>
                </div>
            </Modal>
        </>
    )

}